import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { Listing } from 'models/Listing';
import utils, { checkIsTierPremium, isNewListing } from 'utils';
import { Link } from 'react-router-dom';
import EoiDate from 'components/EoiDate';
import LocationmarkerIcon from 'icons/Locationmarker.icon';
import StatusBadge from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/StatusBadge';
import { getImgUrl } from 'components/ResolveImage/utils';
import ListingActions from 'router/subrouters/Dash/subrouters/Business/components/ListingActions';

import './DistressedListingCard.styles.scss';
import './DistressedListingCard.styles.responsive.scss';

type DistressedListingCardProps = {
  className?: string;
  listing: Listing;
  onWatchlisted: (isWatchlisted: boolean) => void;
};

const DistressedListingCard: React.FC<DistressedListingCardProps> = (props) => {
  const { className, listing, onWatchlisted } = props;

  const {
    listingTitle,
    industry,
    gallery,
    locationPostcode,
    createdAt,
    slugName,
    businessDescription,
    type,
    listingContact,
    seekingExpressionOfInterestDate,
    tier,
  } = listing;

  const firmLogo = listingContact?.firmLogo?.url;

  const isListingPremium = checkIsTierPremium(tier);

  const classes = classNames('urgent-campaigns-listing-card', className);

  const redirectionListingLink = utils.composeBusinessUrl(
    industry,
    slugName,
    type,
  );

  return (
    <div className={classes}>
      <div className="urgent-campaigns-listing-card__left">
        <div className="urgent-campaigns-listing-card__left__heading">
          <StatusBadge isNew={isNewListing(createdAt)} />
          <Link
            className="urgent-campaigns-listing-card__left__heading__title"
            to={redirectionListingLink}
          >
            {listingTitle}
          </Link>
          <Link
            to={redirectionListingLink}
            className="urgent-campaigns-listing-card__left__heading__listing-type"
          >
            <span>
              <LocationmarkerIcon />
              {locationPostcode}
            </span>
            <span>{industry}</span>
          </Link>
        </div>
        <EoiDate
          seekingExpressionOfInterestDate={seekingExpressionOfInterestDate}
        />
        <Link
          className="urgent-campaigns-listing-card__left__description"
          to={redirectionListingLink}
        >
          {businessDescription}
        </Link>

        <ListingActions listing={listing} onWatchlisted={onWatchlisted} />
      </div>

      <Link
        aria-label="Business details page"
        className="urgent-campaigns-listing-card__gallery-img"
        to={redirectionListingLink}
      >
        <ResolveImage
          src={getImgUrl(gallery[0]?.url, '320')}
          alt="Listing gallery."
          shouldLazyLoad={false}
        />
        {isListingPremium && firmLogo && (
          <ResolveImage
            asCompanyLogo
            alt="Company logo."
            src={getImgUrl(firmLogo, '240')}
            shouldLazyLoad={false}
          />
        )}
      </Link>
    </div>
  );
};

export default DistressedListingCard;
